export const directionUnitTypes = {
  METRE_M: "Metre (m)",
  YARD_YD: "Yard (yd)",
  MINUTE_MIN: "Minute (min)",
};
